import { Product } from '../../../../commonTypes/StoreTypes'
import beam from '../beam'

export const getProducts = async () => beam.get<Product[]>('/modules/shopify/products')

export const getCustomCookie = () => beam.get<Product>('/modules/shopify/customCookie')
